import { useNavigate } from "react-router-dom";
import { useTranslate } from "@refinedev/core";
import styled from "styled-components";
import { UserCircleIcon } from "@phosphor-icons/react";
import { LiveViewersBadge } from "pages/media/analytics/components/LiveViewersBadge";
import { OrganizationLiveNotifications } from "pages/media/analytics/components/OrganizationLiveNotifications";
import { radius } from "@libertify/ui";

export const TopBar = () => {
  const navigate = useNavigate();
  const t = useTranslate();

  return (
    <TopBarWrapper>
      <TopBarActions>
        <LiveViewersBadge />
        <OrganizationLiveNotifications />
        <TopBarIconButton
          aria-label={t("src.components.TopBar.profile")}
          onClick={() => navigate("/settings")}
        >
          <UserCircleIcon size={24} />
        </TopBarIconButton>
      </TopBarActions>
    </TopBarWrapper>
  );
};

const TopBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const TopBarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TopBarIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: ${radius.circle};
  border: none;
  background: none;
  color: #9399a6;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
